export default "__VITE_ASSET__MzPMsRhm__"